module.exports = __webpack_public_path__ + "img/visa-assistant-ico.8ae85a58.svg";